import React from "react";
import "./Successful_toaster.css";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

const Successful_toaster = ({ show, onClose, message }) => {
  return (
    <ToastContainer position="top-end" className="p-3">
      <Toast onClose={onClose} show={show} delay={3000} autohide>
        <Toast.Header></Toast.Header>
        <Toast.Body>
          <p className="success_msg">
            <img
              className="sucess-icon"
              src={process.env.PUBLIC_URL + "/assets/images/icons/success.png"}
            />
            {message}
          </p>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Successful_toaster;
